/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { LEVELS, log } from '../logs'
import Card from './Card'

export const CardSet = props => {
  log('CardSet', LEVELS.INFO, props)
  const { cards, cardRefids, width = '40px', height = '40px', showNext, max } = props
  return (
    <div className='card-set'>
      {
        cardRefids.map((refid, index) => {
          const style = {
            width,
            height
          }
          if (max && index >= max) {
            style.opacity = 0.3
          }
          return (
            <div
              style={style}
              key={refid}
            >
              <Card
                image={cards[refid].image}
                transform={{ s: 1.0 }}
                flipped
                size={100}
              />
            </div>
          )
        })
      }
      {
        showNext
          ? <div
              className='card-slot'
              key={cardRefids.length}
              style={{
                width,
                height,
                border: '1px dotted black'
              }}
            />
          : ''
      }
    </div>
  )
}

CardSet.displayName = 'CardSet'
